import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { selectRemindBarShow } from "features/metadesk/redux/globalState/globalState.selector";
import { setRemindBarShow } from "features/metadesk/redux/globalState/globalState.action";
import useNavigateEntity from "hooks/useNavigateEntity";
import { selectDemoSite } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { Banner } from "@metacrm/metacrm-material-ui/dist/Banner";

export default function RemindBanner() {
  const { formatMessage } = useIntl();
  const isDemoSite = useSelector(selectDemoSite);
  const dispatch = useDispatch();
  const remindBarShow = useSelector(selectRemindBarShow);
  const [bannerDialogOpen, setBannerDialogOpen] = useState(false);
  const [dontShowBannerAgain, setDontShowBannerAgain] = useState(false);
  const { navigateEntity } = useNavigateEntity();

  const handleCloseRemindBar = () => {
    if (dontShowBannerAgain) {
      localStorage.setItem("version_remind_not_show", true);
    }
    dispatch(setRemindBarShow(false));
  };

  const handleToIntegration = () => {
    navigateEntity("/settings/general/app/update-list");
  };

  if (isDemoSite) return <div />;
  return (
    <Banner
      show={remindBarShow}
      message={formatMessage({ id: "global.portal.upgrade.description" })}
      onClickCloseIcon={() => setBannerDialogOpen(true)}
      buttonText={formatMessage({ id: "global.upgrade.button" })}
      onButtonClick={handleToIntegration}
      showDialog
      dialogOpen={bannerDialogOpen}
      setDialogOpen={setBannerDialogOpen}
      dialogTexts={{
        dialogTitle: formatMessage({ id: "popup.versionNotification.title" }),
        dialogMessage: formatMessage({
          id: "popup.versionNotification.description",
        }),
        dialogBtnConfirmText: formatMessage({ id: "global.btn.confirm" }),
        dialogBtnCancelText: formatMessage({ id: "global.btn.cancel" }),
        dialogReminderText: formatMessage({ id: "global.btn.reminder" }),
      }}
      onClickConfirmCloseBanner={handleCloseRemindBar}
      dontShowBannerAgain={dontShowBannerAgain}
      setDontShowBannerAgain={setDontShowBannerAgain}
    />
  );
}
